import { render } from "./TraineeToTrainerCriteria.vue?vue&type=template&id=08d81791"
import script from "./TraineeToTrainerCriteria.vue?vue&type=script&lang=js"
export * from "./TraineeToTrainerCriteria.vue?vue&type=script&lang=js"

import "./TraineeToTrainerCriteria.vue?vue&type=style&index=0&id=08d81791&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__